var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-container"},[_c('router-link',{staticClass:"back",attrs:{"to":{ name: 'authorizations.index' }}},[_c('i',{staticClass:"icon-previous"}),_vm._v(" retour liste autorisations ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }